import React from 'react'
import IconButton from '@material-ui/core/IconButton'

import ExpandButtonSvg from 'components/CommonUI/svgIcons/ExpandButtonSvg'

const ExpandButton = ({ onClick }) => {
  return (
    <IconButton className="expand_button_container" onClick={onClick}>
      <ExpandButtonSvg />
    </IconButton>
  )
}

export default ExpandButton
